import CONF from '@/Config.js';
import axios from 'axios';

export default {
    registerBarocareUser: function(profile, agreements, card_info, centerId){
        var data = {
            user_id: centerId === null ? process.env.BAROCARE_CLINET_ID : centerId,
            profile: profile,
            agreements: agreements,
            card_info: card_info
        }

        return axios({
            method: 'post',
            url: CONF.REGISTER_BAROCARE_USER,
            data: data
        })
    },
    fetchBarocareName: function(uuid) {
        return axios({
            method: 'get',
            url: CONF.FETCH_BAROCARE_NAME.replace("${client_uuid}", uuid)
        })
    },
    registerBarocareUserSpecify: function(profile, agreements, uuid, groupId) {
        var data = {
            profile: profile,
            agreements: agreements,
        }

        return axios({
            method: 'post',
            url: CONF.REGISTER_BAROCARE_USER_SPECIFY.replace("${client_uuid}", uuid).replace("${group_id}", groupId),
            data: data
        })
    }
}


// WEBPACK FOOTER //
// ./src/api/soldoc.js